/**************************************************
 * Nombre:       Tratamiento_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Checkbox, Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";
import fondo from '../../../Recursos/fondo_agendar.png'
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import {useState} from "react";
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logo from "../../../Recursos/logo_redondo.svg";
import Formulario_Tratamientos from "../../Formularios/Formulario_Tratamientos";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Tratamiento_Portada = () => {
    const {sCell} = useResponsive()
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, Avisos, iniciarCarga, terminar} = useCargador({logoRedondo: logo, funcionUno: setEntidad})
    const [acepto, setAcepto] = useState(true)

    const enviar = async () => {

        let entidad = await obtenerEntidad()
        iniciarCarga('Enviando Datos')

        let dox = await guardarDoc('autorizaciones', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos enviados con exito, pronto nos contactaremos contigo'})
        } else {
            terminar({aviso: 'Algo indesperado paso, porfavor intentalo nuevamente', variante: 'error'})
        }


    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Cargador/>

            <Avisos/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}

                    >


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 9, md: 6}}
                            sx={{
                                backgroundImage: `url(${fondo})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                p: 4,
                                mt: 6
                            }}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                                <Typography sx={{
                                    fontFamily: NEGRITA,
                                    color: theme.palette.primary.main,
                                    fontSize: sCell ? 22 : 32,
                                    lineHeight: 1.2,
                                    textAlign: sCell ? 'center' : 'left'
                                }}>
                                    SOLICITUD DE ASESORÍA Y RADICACIÓN DE CASOS
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{
                                    color: theme.palette.primary.main,
                                    fontSize: sCell ? 14 : 16,
                                    mt: 1,
                                    textAlign: sCell ? 'center' : 'left'
                                }}>
                                    Inicie su trámite legal con total seguridad procesal. Ingrese sus datos en el
                                    siguiente
                                    formulario para que uno de nuestros abogados conciliadores evalúe su caso bajo
                                    estricta
                                    reserva. </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                                <Formulario_Tratamientos props={props}/>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', mt: 2, px: 2}}>
                                <Typography sx={{fontSize: sCell ? 14 : 16}}>
                                    <Checkbox checked={acepto} onChange={() => setAcepto(!acepto)}
                                              sx={{mt: -0.2, p: 0}}
                                    /> Acepto de manera expresa e informada la Política de Tratamiento de Datos
                                    Personales del Centro y autorizo el uso de mis canales de contacto para
                                    notificaciones del trámite.
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'center', mt: 2, mb: 2}}>
                                <Button
                                    disabled={!acepto}
                                    onClick={() => enviar()}
                                >Enviar</Button>
                            </Grid>


                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 6}}
                            sx={{
                                px: 4,
                                mt: 4
                            }}
                        >


                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', ml: sCell ? -3 : 0}}>
                                <Typography sx={{lineHeight: 1.2, textAlign: 'justify'}}>

                                    <h2><strong>POLÍTICA DE TRATAMIENTO DE DATOS PERSONALES</strong></h2><p><strong>CENTRO
                                    DE CONCILIACIÓN SOLUCIONES DE CONFLICTOS PARA LA PAZ</strong></p><p>En cumplimiento
                                    de la <strong>Ley Estatutaria 1581 de 2012</strong>, el <strong>Decreto Regulador
                                        1074 de 2015</strong> y demás normas concordantes en la República de Colombia,
                                    nuestro Centro de Conciliación Privado (en adelante, el Centro), en su calidad
                                    de Responsable del Tratamiento, establece las siguientes directrices para la
                                    recolección, almacenamiento, uso, circulación y supresión de datos personales.</p>
                                    <p><br/></p><h3><strong>1. Canales Oficiales de Atención para Derechos HABEAS
                                    DATA</strong></h3><p>Para ejercer sus derechos de conocer, actualizar, rectificar o
                                    suprimir su información, los titulares de los datos pueden comunicarse a través de
                                    los canales exclusivos de atención del Centro:</p>
                                    <ul>
                                        <li><strong>Correo Electrónico:</strong> cc.soluciondeconflictos22@gmail.com
                                        </li>
                                        <li><strong>Línea Telefónica / WhatsApp:</strong> +57 301 524 3727</li>
                                    </ul>
                                    <h3><strong>2. Tratamiento de Datos Sensibles</strong></h3><p>Por la naturaleza de
                                    los Mecanismos Alternativos de Solución de Conflictos (MASC), el Centro recolecta y
                                    procesa de manera excepcional <strong>datos sensibles</strong> (información asociada
                                    a la salud, relaciones familiares, minorías, datos biométricos, entre otros).</p><p>
                                    <br/></p>
                                    <ul>
                                        <li><strong>Autorización:</strong> El Tratamiento de estos datos contará siempre
                                            con la autorización explícita del titular o su apoderado, salvo en las
                                            excepciones contempladas por el artículo 6 de la Ley 1581 de 2012,
                                            especialmente cuando sea necesario para el reconocimiento, ejercicio o
                                            defensa de un derecho en un proceso legal.
                                        </li>
                                        <li><strong>Reserva y Confidencialidad:</strong> Toda la información recolectada
                                            está cobijada por el principio constitucional de confidencialidad de la
                                            conciliación.
                                        </li>
                                    </ul>
                                    <h3><strong>3. Finalidades del Tratamiento de Datos</strong></h3><p>Los datos
                                    recolectados por el Centro se agruparán en dos grandes esferas según la vinculación
                                    del usuario:</p><p><br/></p><h4><strong>A. En el Ámbito Jurídico y Misional
                                    (Conciliación, Arbitraje, Insolvencia, Mediación y Amigable Composición):</strong>
                                </h4>
                                    <ol>
                                        <li>Gestionar la radicación de solicitudes, citaciones y el desarrollo de
                                            audiencias presenciales o virtuales.
                                        </li>
                                        <li>Cumplir con la obligación legal de reportar, registrar y validar las actas,
                                            laudos y constancias ante el Sistema de Información de la Conciliación, el
                                            Arbitraje y la Amigable Composición (<strong>SICAAC</strong>) del Ministerio
                                            de Justicia y del Derecho de Colombia.
                                        </li>
                                        <li>Establecer contacto directo con las partes del conflicto, apoderados
                                            (abogados) y terceros intervinientes exclusivamente para fines del impulso
                                            procesal.
                                        </li>
                                    </ol>
                                    <h4><strong>B. En el Ámbito Educativo y de Oferta Académica (Diplomados, Cursos y
                                        Formación Escolar):</strong></h4>
                                    <ol>
                                        <li>Gestionar la inscripción, matrícula y control de asistencia de los
                                            estudiantes del Diplomado en Conciliación en Derecho u otros programas
                                            formativos.
                                        </li>
                                        <li>Tramitar ante el Ministerio de Justicia y del Derecho el registro y
                                            certificación oficial de los estudiantes capacitados en el
                                            sistema <strong>SICAAC</strong>.
                                        </li>
                                        <li>Coordinar con las instituciones educativas y padres de familia el desarrollo
                                            de los programas de formación de Mediadores Escolares (Ley 1620 de 2013).
                                        </li>
                                        <li>Enviar información académica, actualizaciones normativas (MASC) y ofertas
                                            formativas propias del Centro.
                                        </li>
                                    </ol>
                                    <h3><strong>4. Derechos de los Titulares</strong></h3><p>Los usuarios, estudiantes,
                                    abogados y partes procesales tienen derecho a:</p>
                                    <ul>
                                        <li>Conocer, actualizar y rectificar sus datos personales frente al Centro.</li>
                                        <li>Solicitar prueba de la autorización otorgada, salvo excepción legal.</li>
                                        <li>Ser informados sobre el uso que se les ha dado a sus datos.</li>
                                        <li>Revocar la autorización o solicitar la supresión del dato <strong>siempre y
                                            cuando no exista un deber legal o contractual</strong> de permanecer en la
                                            base de datos (por ejemplo, expedientes e informes que por ley deben reposar
                                            permanentemente en el archivo del Centro o el sistema SICAAC).
                                        </li>

                                    </ul>
                                    <h3><strong>5. Vigencia de las Bases de Datos</strong></h3><p>Los datos personales
                                    asociados a la oferta educativa y comercial se conservarán mientras se mantenga la
                                    relación o el titular no solicite su supresión. Los datos contenidos en las actas de
                                    conciliación, laudos, expedientes de insolvencia y registros oficiales del
                                    Ministerio de Justicia permanecerán archivados de manera indefinida en cumplimiento
                                    de los términos legales de conservación de documentos judiciales.</p><p>Apenas
                                    cargues el documento de la política educativa que ya tienes armada, revisaré los
                                    textos exactos para fusionarlos, añadir los párrafos específicos que falten y
                                    entregarte el documento final perfectamente unificado.</p>

                                </Typography>
                            </Grid>


                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Tratamiento_Portada